import { Grid, makeStyles } from '@material-ui/core';
import { PartnerOptionDataField } from 'api-clients/monolith';
import React, { useEffect, useState, VFC } from 'react';

import { DETAIL_TYPES } from 'components/ApplicantDrawerDetailsList/constants';
import useGetPartnerOptionData from 'hooks/partners/useGetPartnerOptionData';

import { Field } from './field';

const useStyles = makeStyles(theme => ({
  editPartnerData: {
    color: theme.palette.common.black,
  },
}));

interface EditPartnerOptionDataFormProps {
  applicantId: string;
  stageId: string;
  partnerOptionId: string;
  partnerStatusId?: string;
}

export const EditPartnerOptionDataForm: VFC<EditPartnerOptionDataFormProps> = ({
  applicantId,
  stageId,
  partnerOptionId,
  partnerStatusId,
}) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [partnerOptionDataId, setPartnerOptionDataId] = useState('');
  const [partnerOptionData, setPartnerOptionData] = useState<
    PartnerOptionDataField[]
  >([]);

  const { result, refetch } = useGetPartnerOptionData({
    applicantId,
    stageId,
    partnerOptionId,
    partnerStatusId,
  });

  useEffect(() => {
    if (result.status === 'ready' && result.data) {
      setPartnerOptionData(result.data.data_fields);
      setPartnerOptionDataId(result.data.partner_option_data_id);
      setIsLoading(false);
    }
  }, [result]);

  return isLoading ? (
    <></>
  ) : (
    <Grid>
      {partnerOptionData.map(data => {
        switch (data.type) {
          case DETAIL_TYPES.availability:
          case DETAIL_TYPES.checkboxes:
          case DETAIL_TYPES.date_picker:
          case DETAIL_TYPES.dropdown:
          case DETAIL_TYPES.license_data:
          case DETAIL_TYPES.radio:
          case DETAIL_TYPES.text_area:
          case DETAIL_TYPES.text_field:
            return (
              <Field
                className={classes.editPartnerData}
                applicantId={applicantId}
                detail={data}
                key={`${applicantId}-${data.key}`}
                partnerOptionDataId={partnerOptionDataId}
                refreshData={refetch}
              />
            );
          default:
            return <></>;
        }
      })}
    </Grid>
  );
};

export default EditPartnerOptionDataForm;
